import { ThemeOptions } from '@mui/material';

import { tokens } from '../../theme/generated/tokens';
import { cssVars } from '../../utils/cssVars';

const { getters, setValues } = cssVars<{
  px?: string;
  height?: string;
  fontSize?: string;
  fontWeight?: string;
  lineHeight?: number;
  letterSpacing?: string;
  textTransform?: string;
  overlayIconSize?: string;
  gap?: string;
}>(
  {
    px: '8px',
    gap: '4px',
    height: '24px',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: 1,
    letterSpacing: undefined,
    textTransform: undefined,
    overlayIconSize: '12px',
  },
  'ds-chip'
);

export const chipTheme: ThemeOptions['components'] = {
  DsChip: {
    styleOverrides: {
      root: ({ ownerState }) => ({
        width: 'max-content',
        display: 'inline-flex',
        alignItems: 'center',
        backgroundColor: tokens.theme.bg.structural.surfaceRaised,
        color: tokens.theme.fg.structural.primary,
        borderRadius: tokens.theme.radius.sm,
        paddingLeft: getters.px(),
        paddingRight: getters.px(),
        height: !ownerState?.multiline ? getters.height() : undefined,
        minHeight: ownerState?.multiline ? getters.height() : undefined,
        fontSize: getters.fontSize(),
        fontWeight: getters.fontWeight(),
        lineHeight: getters.lineHeight(),
        letterSpacing: getters.letterSpacing(),
        textTransform: getters.textTransform(),
        gap: getters.gap(),
        fontFamily: tokens.primitives.fontFamily.body,
        '&.Ds-disabled': {
          backgroundColor: tokens.theme.disabled.bg,
          color: tokens.theme.disabled.fg,
        },
        cursor: ownerState?.onClick ? 'pointer' : undefined,
      }),
      iconChip: {
        width: getters.height(),
        paddingLeft: 0,
        paddingRight: 0,
        justifyContent: 'center',
      },
      sm: ({ theme }) => ({
        ...setValues({
          ...theme.typography.P10M,
          px: '6px',
          height: '20px',
        }),
      }),
      md: ({ theme }) => ({
        ...setValues({
          ...theme.typography.P12M,
          px: '8px',
          height: '24px',
        }),
      }),
      lg: ({ theme }) => ({
        ...setValues({
          ...theme.typography.P14M,
          px: '8px',
          height: '28px',
          overlayIconSize: '16px',
        }),
      }),
      content: ({ ownerState }) => ({
        cursor: ownerState?.onClick ? 'pointer' : 'default',
        display: 'flex',
        position: 'relative',
        whiteSpace: 'pre-wrap',
        ...(ownerState?.multiline && {
          wordBreak: 'break-all',
          lineHeight: '18px',
        }),
      }),
      iconWrapper: {
        display: 'flex',
      },
      destroyIcon: {
        fontSize: 'calc(1em + 2px)',
        fontWeight: 'bold',
        cursor: 'pointer',
        opacity: 0.4,
        '&:hover': {
          opacity: 1,
        },
        '.Ds-disabled &': {
          cursor: 'default',
          opacity: 0.2,
        },
      },
      destroyIconWrapper: {
        paddingLeft: 4,
      },
      overlayIconWrapper: {
        position: 'absolute',
        top: 0,
        right: 0,
        transform: `translate(calc(50% + ${getters.px()}), -50%)`,
        '.DsChip-OverlayIcon': {
          fontSize: getters.overlayIconSize(),
        },
      },
    },
  },
};
